"use client"

import { SquareSquare } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `SquareSquareIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const SquareSquareIcon = component(Icon)({ as: SquareSquare })
